import { liabilityFunctions } from "./liability";
import { hasPositiveUMAvailable, isReducedUMZeroByLiability } from "./misc";
import { umPolicyStatusOptionsPayerTypes } from "./systemData";

export const umFunctions = {
    umVerification: (umArr, liability) => {
        // Improved readability for UM verification logic

        // Helper: Format messages as HTML
        const formatMessages = (messages) => {
            if (!messages || messages.length === 0) return null;
            const html = messages.map(msg => `<div>${msg}</div>`).join('');
            return `<div>${html}</div>`;
        };

        // Initialize tab state
        let tabState = {
            dot: false,
            dot_color: null,
            background: null,
            color: null,
            message: null
        };

        const liabilities = Array.isArray(liability) ? liability : (liability ? [liability] : [])
        const rawPrimaryLiability = liabilities.find(item => item.is_primary_insurance) || null
        const validPrimaryLiability = liabilityFunctions.isLiabilityValid(liabilities, 'policy_limit_patient')

        // Find primary UM insurance
        let primaryInsurance = null;
        if (umArr && Array.isArray(umArr) && umArr.length > 0) {
            primaryInsurance = umArr.find(item => item.is_um_primary_insurance) || null;
        } else if (umArr && !Array.isArray(umArr)) {
            primaryInsurance = umArr;
        }

        if (primaryInsurance) {
            let messages = [];

            // old logic for various fileds, replaced by status colors
            // Case: No UM coverage
            // if (primaryInsurance.has_um == 0) {
            //     messages.push('Insurance has No UM');
            //     tabState.background = 'linear-gradient(0deg, var(--red-transparent) 0%, var(--red-transparent) 100%), var(--background)';
            //     tabState.color = 'var(--red)';
            // } else {
            //     // Case: All correct (Green)
            //     const isGreen = primaryInsurance.um_verified 
            //         && primaryInsurance.has_um == 1 
            //         && primaryInsurance.um_type !== null;

            //     if (isGreen) {
            //         tabState.background = 'var(--green-verification)';
            //         tabState.color = 'var(--text)';
            //     }

            //     if (primaryInsurance.has_um) {
            //         // Case: Policy not verified (Yellow)
            //         if (!primaryInsurance.um_verified) {
            //             messages.push('Policy is not verified');
            //             tabState.background = 'linear-gradient(0deg, var(--orange2-transparent) 0%, var(--orange2-transparent) 100%), var(--background)';
            //             tabState.color = 'var(--dark-yellow)';
            //         }

            //         // Case: Negotiation split selected (Orange)
            //         if (primaryInsurance.um_neg_split) {
            //             messages.push('Negotiation - Split is selected');
            //             tabState.background = 'var(--orange1)';
            //         }





            //         // Dots and red flags
            //         const setDotRed = () => {
            //             tabState.dot = true;
            //             tabState.dot_color = 'var(--red)';
            //         };

            //         if (primaryInsurance.driver_excluded) {
            //             messages.push('Driver Excluded');
            //             setDotRed();
            //         }

            //         if (!primaryInsurance.um_claim_number && !primaryInsurance.policy_number) {
            //             messages.push('Policy Number was not provided');
            //             setDotRed();
            //         }

            //         if (primaryInsurance.um_verified && !primaryInsurance.um_claim_number) {
            //             messages.push('Claim Number was not provided');
            //             setDotRed();
            //         }

            //         if (primaryInsurance.um_verified && !primaryInsurance.um_amount) {
            //             messages.push('UM amount was not provided');
            //             setDotRed();
            //         }

            //         // Liability misc dot flags
            //         if (primaryLiability) {
            //             if (primaryLiability.ins_owner == 2) {
            //                 messages.push('Liability - Patient at fault - Passenger (Household member)');
            //                 setDotRed();
            //             }
            //             if (Number(primaryLiability.ins_owner) == 3) {
            //                 messages.push('Liability - Patient at fault - Passenger (Non-Household member)');
            //                 setDotRed();
            //             }
            //         }
            //     }

                
            // }

            const isVerified = primaryInsurance.um_verified == 1 || primaryInsurance.um_verified === true;
            const isReducedZeroByLiability = primaryInsurance.has_um != 0
                && primaryInsurance.um_type == 1
                && isReducedUMZeroByLiability(validPrimaryLiability, primaryInsurance);

            if (primaryInsurance.has_um == 0) {
                messages.push('Insurance has No UM');
                tabState.background = 'linear-gradient(0deg, var(--red-transparent) 0%, var(--red-transparent) 100%), var(--background)';
                tabState.color = 'var(--red)';
            }  else {
                // START status color logic
                let option = umPolicyStatusOptionsPayerTypes()?.find(item => item.value == primaryInsurance.um_status)
    
                if (option) {
                    tabState.classColor = 'bk_' + option.color?.split(' ').join('_')
                }

                if (!isVerified) {
                    messages.push('Policy is not verified');
                    tabState.background = 'linear-gradient(0deg, var(--orange2-transparent) 0%, var(--orange2-transparent) 100%), var(--background)';
                    tabState.color = 'var(--dark-yellow)';
                    tabState.classColor = null;
                }

                if (isVerified && hasPositiveUMAvailable(validPrimaryLiability, primaryInsurance)) {
                    tabState.background = 'var(--green1-transparent)';
                    tabState.color = 'var(--text)';
                    tabState.classColor = null;
                }

                if (isVerified && primaryInsurance.um_neg_split) {
                    messages.push('Negotiation - Split is selected');
                    tabState.background = 'var(--orange1)';
                    tabState.classColor = null;
                }

                if (isReducedZeroByLiability) {
                    //messages.push('Reduced UM availability is $0.00 (liability exceeds UM limits)');
                    tabState.background = 'linear-gradient(0deg, var(--red-transparent) 0%, var(--red-transparent) 100%), var(--background)';
                    tabState.color = 'var(--red)';
                    tabState.classColor = null;
                }
                
            }

            const setDotRed = () => {
                tabState.dot = true;
                tabState.dot_color = 'var(--red)';
            };

            if (primaryInsurance.driver_excluded) {
                messages.push('Driver Excluded');
                setDotRed();
            }

            if (!primaryInsurance.um_claim_number && !primaryInsurance.policy_number) {
                messages.push('Policy Number was not provided');
                setDotRed();
            }

            if (primaryInsurance.um_verified && !primaryInsurance.um_claim_number) {
                messages.push('Claim Number was not provided');
                setDotRed();
            }

            if (primaryInsurance.um_verified && !(primaryInsurance.um_policy_limit_patient)) {
                messages.push('UM limit patient was not provided');
                setDotRed();
            }
            
            if (primaryInsurance.um_verified && !(primaryInsurance.um_policy_limit_accident)) {
                messages.push('UM limit accident was not provided');
                setDotRed();
            }

            // Liability misc dot flags
            if (rawPrimaryLiability) {
                if (rawPrimaryLiability.ins_owner == 2) {
                    messages.push('Liability - Patient at fault - Passenger (Household member)');
                    setDotRed();
                }
                if (Number(rawPrimaryLiability.ins_owner) == 3) {
                    messages.push('Liability - Patient at fault - Passenger (Non-Household member)');
                    setDotRed();
                }
            }

            // END status color logic


            // Assign message if any exists
            tabState.message = formatMessages(messages);
        }

        return tabState;
    }
}